import { yupResolver } from "@hookform/resolvers/yup";
import React, { useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FormProps } from "shared/interfaces/container/form/form";

export default function Form<TValue>({
    children,
    schema,
    defaultValues,
    onHandleSubmit,
    className,
    mode,
    shouldUnregister,
    submitOnEnter = false,
}: FormProps<TValue>): JSX.Element {
    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues,
        reValidateMode: "onBlur",
        mode: mode || "onSubmit",
        shouldUnregister,
    });
    const { handleSubmit } = methods;
    const onKeyDown = useMemo(() => {
        if (submitOnEnter) {
            return undefined;
        }
        return (event: React.KeyboardEvent) => {
            if (event.key === "Enter" && event.target instanceof HTMLInputElement) {
                event.preventDefault();
            }
        };
    }, [submitOnEnter]);

    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onHandleSubmit)} className={className} onKeyDown={onKeyDown}>
                {children}
            </form>
        </FormProvider>
    );
}
